import { getCirugia, postCirugia } from "./ApiHIS"

export const getMaestroPaquetesQx=(body)=>{
    return postCirugia('clinico/paquetesqx/obtenerPaquetesQx',body)
}

export const postDataListaSuministrosPQx=(body)=>{
    return postCirugia('clinico/paquetesqx/dataListaSuministros',body)
}

export const postInsertPaqueteYSuministros=(body)=>{
    return postCirugia('clinico/paquetesqx/dataInsertarPaqueteYSuministros', body)
}

export const postInsertarSuministroEnPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/insertarSuministroEnPaquetesQx', body)
}

export const postSuministrosDeUnPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/obtenerSuministroDeUnPaqueteQx',body)
}

export const postDeleteUnSuministroDeUnPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/eliminarUnSuministroDeUnPaqueteQx', body)
}

export const postUpdateAUnPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/actualizarUnPaqueteQx',body)
}

export const postDeleteSuministrosYPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/deleteSuministrosYPaqueteQx', body)
}

export const postDeleteTodosLosSuministrosUnPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/deleteTodosLosSuministrosDeUnPaqueteQx',body)
}

export const postactualizarSuministrosUnPaqueteQx=(body)=>{
    return postCirugia('clinico/paquetesqx/actualizarSuministrosUnPaqueteQx',body)
}

//resultados
export const postObtenerTodosResultadosProcedimientos=(body)=>{
    return postCirugia('clinico/resultados/obtenerTodosResultadosProcedimientos',body)
}

export const postInsertUnResultadoProcedimiento=(body)=>{
    return postCirugia('clinico/resultados/insertUnResultadoProcedimiento',body)
}

export const postUpdateUnResultadoProcedimiento=(body)=>{
    return postCirugia('clinico/resultados/updateUnResultadoProcedimiento',body)
}

export const postDeleteUnResultadoProcedimiento=(body)=>{
    return postCirugia('clinico/resultados/deleteUnResultadoProcedimiento', body)
}

export const postFirmaMedico=(body)=>{
    return postCirugia('clinico/firmaMedico/obtenerMedicoPorCedula', body)
}

export const postModificarFirmaMedico=(body)=>{
    return postCirugia('clinico/firmaMedico/actualizarFirmaMedico',body)
}